
document.addEventListener("DOMContentLoaded", function () {


  document.querySelectorAll(".connectlist").forEach( container => {
    
    const posts = container.querySelectorAll(".wp-block-post");

    container.querySelectorAll('.wp-block-categories-list a').forEach(link => {
      link.addEventListener("click", function (e) {
        e.preventDefault();

        // Get slug and category from link href
        const url = new URL(link.href);
        const pathParts = url.pathname.split("/").filter(Boolean);
        const slug = pathParts[pathParts.length - 1];
        const category = pathParts[pathParts.length - 2];

        posts.forEach(post => {
          if (post.classList.contains(`${category}-${slug}`)) {
            post.style.display = "";
          } else {
            post.style.display = "none";
          }
        });
      });
    });
  });


});
